import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Kevin Lobos | Front End Software Developer', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my portfolio!', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Kevin Lobos',
  subtitle: "I'm a Front End Software Developer",
  cta: 'Find out more!',
};
//'Firebase.png','Redux.png',
// ABOUT DATA
export const aboutData = {
  skills:['React.png','Redux','Firebase','Node.png','Express.png','Python.png','JavaScript.png','HTML5.png','CSS3.png','Sass.png','P5.png'],
  resume: 'Kevin-Resume.pdf', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'movie-app.png',
    title: 'Binge Movies',
    info: "Netflix clone created with React and Redux, with authentication from Firebase. Checkout from Stripe.js. Data pulled in from the TMDB API database.",
    techUsed:["React.png",'firebase-icon.png','Redux','JavaScript.png','CSS3.png'],
    url: 'https://movie-app-44184.web.app/',
    repo: 'https://github.com/kevinlobos42/react-movie-site', 
  },
  {
    id: nanoid(),
    img: 'React Path Finder.png',
    title: 'Pathfinder',
    info: "React web application that used Dijkstra's algorithm and A* algorithm to determine the shortest path from 1 point to another on a graph. Styled with CSS3 and Material UI.",
    techUsed:["React.png",'JavaScript.png','CSS3.png'],
    url: 'http://find-path.netlify.app',
    repo: 'https://github.com/kevinlobos42/path-finder', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'React Sorting Visualizer.png',
    title: 'Sorting Algorithm Visualizer',
    info: 'React web application that animates how sorting algorithms sort an array from smallest to largest. Algorithms used include: BubbleSort, QuickSort, and MergeSort. Styled with CSS3 and Material UI.',
    techUsed:['React.png','JavaScript.png','CSS3.png'],
    url: 'https://seesort.netlify.app/',
    repo: 'https://github.com/kevinlobos42/sortingVisualizer', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'P5js Minesweeper.png',
    title: 'Minesweeper',
    info: 'P5.js web app that allows the user to play the classic game, Minesweeper. Styled with CSS3',
    techUsed:['P5.png','JavaScript.png','CSS3.png','HTML5.png'],
    url: 'https://sweepthemines.netlify.app/',
    repo: 'https://github.com/kevinlobos42/Minesweeper-p5.js', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: "Let's Talk!",
  btn: "Let's Talk!",
  email: 'kevinlobos42@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'resume',
      url: '',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/kevin-lobos/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/kevinlobos42',
    },
  ],
};

